<template>
    <div class="modal fade" id="InstructorUserModal" tabindex="-1" role="dialog" aria-labelledby="InstructorUserModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="InstructorUserModalLabel">{{ isCreating ? __('instructors.add') : __('instructors.update') }}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="app-card-notification"  v-if="isCreating">
                        <div class="notification-type my-2">
                            <span class="badge bg-info">{{ __('instructors.new-instructor-notification') }}</span>
                        </div>
                    </div>
                    <form>
                        <div class="form-group">
                            <label for="name" class="col-form-label">{{ __('instructors.name') }}:</label>
                            <input type="text" class="form-control" id="name" v-model="instructor.name">
                            <span v-if="errors.name" class="invalid-feedback d-block">{{ errors.name[0] }}</span>
                        </div>
                        <div class="form-group">
                            <label for="email" class="col-form-label">{{ __('instructors.email') }}:</label>
                            <input type="email" class="form-control" id="email" v-model="instructor.email">
                            <span v-if="errors.email" class="invalid-feedback d-block">{{ errors.email[0] }}</span>
                        </div>
                        <div class="form-group">
                            <label for="email" class="col-form-label">{{ __('instructors.wrm-number') }}:</label>
                            <input type="text" class="form-control" id="WRM-number" v-model="instructor.wrm_number">
                            <span v-if="errors.wrm_number" class="invalid-feedback d-block">{{ errors.wrm_number[0] }}</span>
                        </div>
                        <div class="form-group" v-if="!isCreating">
                            <label for="role" class="col-form-label">{{ __('instructors.role') }}:</label>
                            <select class="form-select" id="role" v-model="selectedRole">
                                <option v-for="role in availableRoles" :key="role" :value="role">{{ role }}</option>
                            </select>
                            <span v-if="errors.role" class="invalid-feedback d-block">{{ errors.role[0] }}</span>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn app-btn-secondary" data-bs-dismiss="modal">{{ __('actions.close') }}</button>
                    <button type="button" class="btn app-btn-primary" @click="isCreating ? addUser() : updateUser()" :disabled="isButtonDisabled">{{ buttonText }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "EditUserModal",

    props: {
        availableRoles: {
            type: Array,
            default: () => []
        }
    },

    data: function () {
        return {
            instructor: {
                email: null,
                name: null,
                wrm_number: null,
                role: null
            },
            selectedRole: null,
            errors: [],
            isButtonDisabled: false,
        }
    },

    mounted: function () {
        $('#InstructorUserModal').on('hide.bs.modal', () => {
            this.instructor = {
                email: null,
                name: null,
                wrm_number: null,
                role: null
            }
            this.selectedRole = null
            this.errors = {}
        })
    },

    computed: {
        // Bij aanmaken wordt de rol vooraf gezet via setRole(); bij bewerken niet
        isCreating: function () {
            return !!this.instructor.role;
        },

        buttonText() {
            if (this.isButtonDisabled) {
                return this.__('actions.processing');
            } else {
                return this.__('actions.submit');
            }
        }

    },

    methods: {
        setUser: function (instructor) {
            this.instructor = instructor
            this.selectedRole = instructor.roles && instructor.roles.length > 0
                ? instructor.roles[0].name
                : null
        },

        setRole: function (role) {
            this.instructor.role = role
        },

        addUser: function () {
            this.isButtonDisabled = true;
            axios.post(`/instructors`, this.instructor).then(response => {
                Toast.fire({icon: 'success', title: response.data.message})
                $('#InstructorUserModal').modal('hide')
                this.emit('updated')
            }).catch(error => {
                this.isButtonDisabled = false;
	            Toast.fire({icon: 'error', title: error.response.data.message})
                this.errors = error.response.data.errors
            })
        },

        updateUser: function () {
            this.isButtonDisabled = true;
            const payload = { ...this.instructor, role: this.selectedRole }

            axios.put(`/instructors/${this.instructor.id}`, payload).then(response => {
                Toast.fire({icon: 'success', title: response.data.message})
                $('#InstructorUserModal').modal('hide')
                this.emit('updated')
            }).catch(error => {
                this.isButtonDisabled = false;
	            Toast.fire({icon: 'error', title: error.response.data.message})
                this.errors = error.response.data.errors
            })
        }
    }
}
</script>

<style scoped>

</style>
